export default __webpack_public_path__ + "static/media/brain_defogger.cfc04706.png";